module.exports = __webpack_public_path__ + "img/lijia.90777946.png";